  export default {
	"当前语言": "Ko",

	"公共.没有更多数据了": "더 이상 데이터가 없습니다",
	"公共.加载中": "로딩 중",
	"公共.下拉刷新": "당겨서 새로고침",
	"公共.释放刷新": "놓아서 새로고침",
	"公共.链接钱包": "지갑 연결",

	"首页.轮播.标题": "현실 자산을 신뢰성 있고 안전하며 즉시적으로 체인 위에 흐르게 하다",
	"首页.轮播.描述1": "현실 세계 자산을 향하여",
	"首页.轮播.描述2": "AI 구동 성능 퍼블릭 체인",
	"首页.以太坊": "이더리움",
	"首页.企业绩效管理": "기업 성과 관리",
	"首页.仲裁委员会": "중재 위원회",
	"首页.探索DApps": "DApps 탐색",
	"首页.发现去中心化应用程序": "탈중앙화 애플리케이션 발견",
	"首页.查看所有Dapps": "모든 Dapps 보기",
	"首页.战略合作伙伴": "전략적 파트너",
	"首页.值得信赖的生态系统合作伙伴": "신뢰할 수 있는 생태계 파트너",
	"首页.全部": "전체",
	"首页.去中心化金融": "탈중앙화 금융",
	"首页.非同质化代币": "동질화 불가능한 토큰",
	"首页.最新消息": "최신 소식",
	"首页.保持对Web3关注": "Web3에 계속 주목",
	"首页.官方频道": "공식 채널",

	"首页.官方频道.推特.名称": "Twitter",
	"首页.官方频道.推特.描述": "@web3 플랫폼",
	"首页.官方频道.Discord.名称": "Discord",
	"首页.官方频道.Discord.描述": "@web3 플랫폼",
	"首页.官方频道.电报.名称": "Telegram",
	"首页.官方频道.电报.描述": "공식 업데이트",
	"首页.官方频道.GitHub.名称": "GitHub",
	"首页.官方频道.GitHub.描述": "오픈 소스",

	"首页.标签.Defi": "DeFi",
	"首页.标签.数据分析": "데이터 분석",
	"首页.标签.链游": "블록체인 게임",
	"首页.标签.其他": "기타",
	"首页.标签.DEX": "DEX",

	"首页.合作伙伴.Solana.描述": "Solana는 대규모 채택을 위해 설계된 블록체인입니다. 빠르고 조합 가능하며 친환경적이고 전 세계적으로 탈중앙화되어 있습니다.",
	"首页.合作伙伴.CoinStats.描述": "원스톱 토큰 자산 추적기, 포트폴리오를 쉽고 효율적으로 관리.",
	"首页.合作伙伴.Shaga.描述": "Shaga는 혁신적인 게임 경험 제공을 목표로 합니다.",
	"首页.合作伙伴.Grass.描述": "Grass로 사용하지 않는 인터넷 대역폭을 공유하여 보상을 획득하세요.",
	"首页.合作伙伴.Jupiter.描述": "암호화 분야 최고의 거래소를 구축하고 DeFi 거인이 되는 것을 목표로 합니다.",
	"首页.合作伙伴.boop.fun.描述": "Meme 코인 커뮤니티를 구축하고 BOOP를 스테이킹하여 에어드롭 보상을 해제.",

	"闪兑.闪兑中心": "스왑 센터",
	"闪兑.闪兑": "스왑",
	"闪兑.即时互换": "즉시 교환",
	"闪兑.快速兑换 · 实时到账 · 20:1比例": "빠른 환전 · 실시간 입금 · 20:1 비율",
	"闪兑.极速闪兑": "번개 스왑",
	"闪兑.安全可靠": "안전하고 신뢰할 수 있음",
	"闪兑.RGT余额": "RGT 잔액",
	"闪兑.ROON余额": "ROON 잔액",
	"闪兑.可用于闪兑": "스왑에 사용 가능",
	"闪兑.闪兑获得": "스왑 획득",
	"闪兑.节点等级": "노드 레벨",
	"闪兑.闪兑比例": "스왑 비율",
	"闪兑.闪兑优惠": "스왑 할인",
	"闪兑.手续费": "수수료",
	"闪兑.闪兑数量": "스왑 수량",
	"闪兑.输入RGT数量": "RGT 수량 입력",
	"闪兑.最低": "최소",
	"闪兑.余额": "잔액",
	"闪兑.将获得": "획득 예정",
	"闪兑.立即闪兑": "지금 즉시 스왑",
	"闪兑.闪兑说明": "스왑 설명",
	"闪兑.极速到账": "번개 입금",
	"闪兑.闪兑后ROON立即到账，无需等待": "스왑 후 ROON이 즉시 입금, 대기 불필요",
	"闪兑.安全保障": "안전 보장",
	"闪兑.零手续费": "제로 수수료",
	"闪兑.享受零手续费特权": "제로 수수료 특권을 누림",
	"闪兑.闪兑成功": "스왑 성공",
	"闪兑.ROON已成功转入您的钱包": "ROON이 지갑으로 성공적으로 이체되었습니다",
	"闪兑.消耗RGT": "RGT 소모",
	"闪兑.获得ROON": "ROON 획득",
	"闪兑.确认": "확인",


	"ROON锁仓.ROON锁仓": "ROON 스테이킹",
	"ROON锁仓.线性解锁": "선형 잠금 해제",
	"ROON锁仓.安全锁仓 · 线性解锁 · 随时提取": "안전한 스테이킹 · 선형 잠금 해제 · 언제든지 인출",
	"ROON锁仓.安全锁仓": "안전한 스테이킹",
	"ROON锁仓.总锁仓全部": "총 스테이킹 전부",
	"ROON锁仓.解锁进度": "잠금 해제 진행률",
	"ROON锁仓.已解锁": "잠금 해제됨",
	"ROON锁仓.解锁周期": "잠금 해제 주기",
	"ROON锁仓.周期": "주기",
	"ROON锁仓.可提取金额": "인출 가능 금액",
	"ROON锁仓.提取ROON": "ROON 인출",
	"ROON锁仓.输入提取数量": "인출 수량 입력",
	"ROON锁仓.最低": "최소",
	"ROON锁仓.可提取": "인출 가능",
	"ROON锁仓.立即提取": "지금 즉시 인출",
	"ROON锁仓.锁仓说明": "스테이킹 설명",
	"ROON锁仓.将提取到钱包": "지갑으로 인출",
	"ROON锁仓.ROON已成功转入您的钱包": "ROON이 지갑으로 성공적으로 이체되었습니다",
	"ROON锁仓.闪兑获得的ROON将按照固定周期线性": "스왑으로 획득한 ROON은 고정 주기로 선형적으로",
	"ROON锁仓.随时提取": "언제든지 인출",
	"ROON锁仓.安全保障": "안전 보장",
	"ROON锁仓.智能合约锁仓，资金安全有保障": "스마트 컨트랙트 스테이킹, 자금은 안전하게 보장",
	"ROON锁仓.提取成功": "인출 성공",
	"ROON锁仓.提取金额": "인출 금액",
	"ROON锁仓.确认": "확인",

	"USDR闪兑.USDR闪兑": "USDR 스왑",
	"USDR闪兑.闪兑": "스왑",
	"USDR闪兑.余额": "잔액",
	"USDR闪兑.极速闪兑": "번개 스왑",
	"USDR闪兑.快速兑换 · 安全可靠": "빠른 환전 · 안전하고 신뢰할 수 있음",
	"USDR闪兑.安全可靠": "안전하고 신뢰할 수 있음",
	"USDR闪兑.闪兑比例": "스왑 비율",
	"USDR闪兑.实时汇率": "실시간 환율",
	"USDR闪兑.闪兑数量": "스왑 수량",
	"USDR闪兑.输入USDR数量": "USDR 수량 입력",
	"USDR闪兑.将获得": "획득 예정",
	"USDR闪兑.立即闪兑": "지금 즉시 스왑",
	"USDR闪兑.闪兑记录": "스왑 기록",
	"USDR闪兑.提现记录": "인출 기록",
	"USDR闪兑.兑换成功": "환전 성공",
	"USDR闪兑.已完成": "완료됨",
	"USDR闪兑.处理中": "처리 중",
	"USDR闪兑.消耗": "소모",
	"USDR闪兑.获得": "획득",
	"USDR闪兑.提现": "인출",
	"USDR闪兑.充值": "인출",
	"USDR闪兑.提现金额": "인출 금액",
	"USDR闪兑.可用余额": "사용 가능 잔액",
	"USDR闪兑.提现数量": "인출 수량",
	"USDR闪兑.请输入数量": "수량을 입력하세요",
	"USDR闪兑.提现地址": "인출 주소",
	"USDR闪兑.输入钱包地址": "지갑 주소 입력",
	"USDR闪兑.确认": "확인",

	"ROONMining.LP池": "LP 풀",
	"ROONMining.我的流动性": "마이 유동성",
	"ROONMining.我的LP数据": "마이LP 데이터",
	"ROONMining.累计收益": "누적 수익",
	"ROONMining.剩余天数": "잔여 일수",
	"ROONMining.天": "일",
	"ROONMining.推荐收益": "추천 수익",
	"ROONMining.总本金": "총 원금",
	"ROONMining.添加LP": "LP 추가",
	"ROONMining.我的LP": "마이LP",
	"ROONMining.查看详情": "상세보기",
	"ROONMining.明细": "상세",
	"ROONMining.提现": "출금",
	"ROONMining.更多功能": "더보기 기능",
	"ROONMining.推荐系统": "추천 시스템",
	"ROONMining.直推10%收益": "직추 10% 수익",
	"ROONMining.分红池": "배당 풀",
	"ROONMining.多重收益分配": "다중 수익 배분",
	"ROONMining.NFT权益": "NFT 권익",
	"ROONMining.节点与矿机": "노드와 마이닝 머신",
	"ROONMining.挖矿规则": "마이닝 규칙",
	"ROONMining.20天为一个周期,中间不可撤出LP": "20일을 1사이클로, 중간에 LP 인출 불가",
	"ROONMining.LP每个钱包地址最多添加一次LP": "각 지갑 주소는 최대 1회 LP 추가 가능",
	"ROONMining.每个LP每天收益1个ROON": "각 LP는 매일 1ROON 수익",
	"ROONMining.20天到期:本金+20个ROON": "20일 만기: 원금+20ROON",
	"ROONMining.保障本金+利息,不受价格波动影响": "원금+이자를 보장, 가격 변동 영향 없음",

	"添加流动性.添加流动性": "유동성 추가",
	"添加流动性.重要提示": "중요 안내",
	"添加流动性.每个钱包地址仅可添加一次LP，20天锁定期内无法撤出，请谨慎操作": "각 지갑 주소는 1회만 LP 추가 가능, 20일간 잠금 기간 중 인출 불가, 신중히操作하세요",
	"添加流动性.添加LP组合": "LP 페어 추가",
	"添加流动性.数量": "수량",
	"添加流动性.余额": "잔액",
	"添加流动性.请输入USDR数量": "USDR 수량을 입력하세요",
	"添加流动性.最大": "최대",
	"添加流动性.请输入ROON数量": "ROON 수량을 입력하세요",
	"添加流动性.LP组成比例为": "LP 구성 비율은",
	"添加流动性.挖矿规则": "마이닝 규칙",
	"添加流动性.锁走周期20天，期间无法撤出": "잠금 기간 20일, 기간 중 인출 불가",
	"添加流动性.每天固定收益1个ROON代币": "매일 고정으로 1ROON 토큰 획득",
	"添加流动性.保障本金安全，不受市场价格波动影响": "원금 안전을 보장, 시장 가격 변동 영향 없음",
	"添加流动性.每个钱包地址仅可添加一次LP": "각 지갑 주소는 1회만 LP 추가 가능",
	"添加流动性.所有数据链上透明可查": "모든 데이터는 체인상에서 투명하게 확인 가능",
	"添加流动性.确认添加LP": "LP 추가 확인",
	"添加流动性.您即将添加": "다음을 추가 예정",
	"添加流动性.到流动性池": "유동성 풀에",
	"添加流动性.锁定期": "잠금 기간",
	"添加流动性.天": "일",
	"添加流动性.预计收益": "예상 수익",

	"我的LP.我的LP": "마이LP",
	"我的LP.添加流动性": "유동성 추가",
	"我的LP.进行中": "진행 중",
	"我的LP.已完成": "완료됨",
	"我的LP.总价值": "총 가치",
	"我的LP.剩余": "잔여",
	"我的LP.天": "일",
	"我的LP.锁定中": "잠금 중",
	"我的LP.移除LP": "LP 제거",
  "我的LP.已移除": "제거됨",
  "LP日志.日志明细": "로그 상세",
  "LP日志.确定复投LP": "LP 재투자 확인",
  "LP日志.确定复投": "재투자 확인",
	"我的LP.确认移除LP": "LP 제거 확인",
	"我的LP.您即将移除LP并获得以下资产": "LP를 제거하고 다음 자산을 획득합니다",
	"我的LP.本金返还": "원금 반환",
	"我的LP.收益": "수익",
	"我的LP.总计": "총계",
	"我的LP.确认移除": "제거 확인",

	"持有LP数": "보유 LP 수",
	"我的LP": "마이LP",
	"暂无LP记录": "LP 기록 없음",

	"推荐系统.推荐系统": "추천 시스템",
	"推荐系统.我的团队": "마이 팀",
	"推荐系统.我的推荐人": "마이 추천인",
	"推荐系统.我的推荐码": "마이 추천 코드",
	"推荐系统.复制推荐码": "추천 코드 복사",
	"推荐系统.推荐链接": "추천 링크",
	"推荐系统.复制链接": "링크 복사",
	"推荐系统.分享至推特": "트위터에 공유",
	"推荐系统.分享至电报": "텔레그램에 공유",
	"推荐系统.直接推荐": "직접 추천",
	"推荐系统.间接推荐": "간접 추천",
	"推荐系统.团队人数": "팀 인원수",
	"推荐系统.推荐收益": "추천 수익",
	"推荐系统.总收益": "총 수익",
	"推荐系统.领取收益": "수익 수령",
	"推荐系统.推荐规则": "추천 규칙",
	"推荐系统.推荐奖励": "추천 보상",
	"推荐系统.直接推荐奖励": "직접 추천 보상",
	"推荐系统.间接推荐奖励": "간접 추천 보상",
	"推荐系统.直推人数": "직추 인원",
	"推荐系统.团队总人数": "팀 총 인원",
	"推荐系统.累计收益": "누적 수익",
	"推荐系统.待领取收益": "수령 대기 수익",
	"推荐系统.我的推荐链接": "마이 추천 링크",
	"推荐系统.复制连接": "링크 복사",
	"推荐系统.分享链接给好友，好友添加LP后您将获得其收益的10%作为推荐奖": "친구에게 링크를 공유하면 친구가 LP를 추가한 후 그 수익의 10%를 추천 보상으로 받습니다",
	"推荐系统.当前等级权益": "현재 등급 혜택",
	"推荐系统.个直推": "직추",
	"推荐系统.当前等级": "현재 등급",
	"推荐系统.上级地址": "상위 주소",
	"推荐系统.领取成功": "수령 성공",
	"推荐系统.已成功领取": "성공적으로 수령됨",
	"推荐系统.复制": "복사",
	"推荐系统.收益已发送到您的钱包地址": "수익이 지갑 주소로 전송되었습니다",

	"分红池.分红池": "배당 풀",
	"分红池.持有者": "보유자",
	"分红池.锁仓": "스테이킹",
	"分红池.FOMO": "FOMO",
	"分红池.保险": "보험",

	"分红池.LP持有者分红": "LP 보유자 배당",
	"分红池.分红奖池总额": "총 배당 상금 풀",
	"分红池.我的LP": "마이LP",
	"分红池.持有者列表": "보유자 목록",
	"分红池.分红规则": "배당 규칙",
	"分红池.盈利的25%自动分配给所有LP持有者": "수익의 25%가 모든 LP 보유자에게 자동 배분",
	"分红池.按照LP持有比例进行分红": "LP 보유 비율에 따라 배당",
	"分红池.每周自动发放到钱包地址": "매주 지갑 주소로 자동 지급",
	"分红池.下次分红时间": "다음 배당 시각",
	"分红池.锁仓记录": "잠금 기록",
	"分红池.查看所有ROON锁仓记录": "모든 ROON 잠금 기록 보기",
	"分红池.开始日期": "시작일",
	"分红池.锁定中": "잠금 중",
	"分红池.锁仓时长": "잠금 기간",
	"分红池.已锁定": "잠금됨",
	"分红池.天": "일",
	"分红池.剩余时间": "남은 시간",
	"分红池.已完成": "완료됨",
	"分红池.锁仓已完成，可领取": "잠금 완료, 수령 가능",
	"分红池.锁仓说明": "잠금 안내",
	"分红池.锁走期为1年，期间无法提取": "잠금 기간은 1년, 기간 중 인출 불가",
	"分红池.到期后获得本金+固定收益": "만기 후 원금+고정 수익 획득",
	"分红池.收益来自盈利分配池": "수익은 수익 배분 풀에서 발생",
	"分红池.FOMO池": "FOMO 풀",
	"分红池.奖池总额": "총 상금 풀",
	"分红池.倒计时": "카운트다운",
	"分红池.最后参与": "최종 참여",
	"分红池.排行榜（前20名）": "순위표(상위 20명)",
	"分红池.奖励分配规则": "보상 배분 규칙",
	"分红池.排名": "순위",
	"分红池.奖励": "보상",
	"分红池.第": "제",
	"分红池.名": "명",
	"分红池.平分": "균등 배분",
	"分红池.FOMO规则": "FOMO 규칙",
	"分红池.48小时内无新增参与则触发分配": "48시간 내 신규 참여 없으면 배분 트리거",
	"分红池.保险池每10天转入10%到FOMO池": "보험 풀은 10일마다 10%를 FOMO 풀로 전환",
	"分红池.前20名按排名获得奖励": "상위 20명은 순위에 따라 보상 획득",
	"分红池.保险池": "보험 풀",
	"分红池.保险池总额": "보험 풀 총액",
	"分红池.待转入FOMO池": "FOMO 풀로 전환 예정",
	"分红池.下次转入": "다음 전환",
	"分红池.天后": "일 후",
	"分红池.资金流向": "자금 흐름",
	"分红池.盈利的25%进入保险池": "수익의 25%가 보험 풀로 유입",
	"分红池.每10天转入保险池的10%": "10일마다 보험 풀의 10% 전환",
	"分红池.保险池作用": "보험 풀 역할",
	"分红池.保障系统稳定运行": "시스템 안정 운영 보장",
	"分红池.定期为FOMO池注入资金": "정기적으로 FOMO 풀에 자금 공급",
	"分红池.应对市场波动风险": "시장 변동 리스크 대응",


	"NFT权益.NFT权益": "NFT 권익",
	"NFT权益.NFT权益系统": "NFT 권익 시스템",
	"NFT权益.节点与矿机双重收益": "노드와 마이닝머신 이중 수익",
	"NFT权益.我的NFT": "나의 NFT",
	"NFT权益.NFT收益": "NFT 수익",
	"NFT权益.节点NFT": "노드 NFT",
	"NFT权益.矿机NFT": "마이닝머신 NFT",

	"NFT权益.超级节点": "슈퍼노드",
	"NFT权益.专属权益": "전속 권익",
	"NFT权益.20%额外收益": "20% 추가 수익",
	"NFT权益.优先提现权": "우선 출금권",
	"NFT权益.治理投票权": "거버넌스 투표권",
	"NFT权益.专属客服": "전속 고객센터",
	"NFT权益.价格": "가격",
	"NFT权益.总量": "총량",
	"NFT权益.剩余": "잔여",
	"NFT权益.立即购买": "지금 구매",
	"NFT权益.已拥有": "보유 중",

	"NFT权益.钻石矿机": "다이아몬드 마이닝머신",
	"NFT权益.传说": "전설",
	"NFT权益.算力": "해시파워",
	"NFT权益.日产出": "일일 생산량",
	"NFT权益.史诗": "서사",

	"NFT权益.累计收益": "누적 수익",
	"NFT权益.查看详情": "상세보기",
	"NFT权益.NFT权益说明": "NFT 권익 설명",
	"NFT权益.节点NFT提供额外收益加成和治理权": "노드 NFT는 추가 수익 증가와 거버넌스 권한 제공",
	"NFT权益.矿机NFT提供持续的挖矿产出": "마이닝머신 NFT는 지속적인 채굴 생산 제공",
	"NFT权益.所有NFT权益永久有效": "모든 NFT 권익은 영구적으로 유효",
	
	"质押.质押中": "스테이킹 중",
	"质押.收益": "수익",
	"质押.ROON锁仓": "ROON 스테이킹",
	"质押.天": "일",
	"质押.年化收益率": "연 환산 수익률",
	"质押.最低": "최소",
	"质押.质押金额": "스테이킹 금액",
	"质押.输入质押金额": "스테이킹 금액 입력",
	"质押.最大": "최대",
	"质押.余额": "잔액",
	"质押.立即质押": "지금 스테이킹",
	"质押.我的质押": "나의 스테이킹",
	"质押.查看全部质押": "전체 스테이킹 보기",
	"质押.进行中": "진행 중",
	"质押.天锁定": "일 잠금",
	"质押.年百分率": "연 백분율",
	"质押.质押进度": "스테이킹 진행률",
	"质押.剩余": "잔여",
	"质押.累计收益": "누적 수익",
	"质押.详情": "상세정보",
	
	"销毁挖矿.销毁挖矿": "파괴 마이닝",
	"销毁挖矿.实时销毁数据": "실시간 파괴 데이터",
	"销毁挖矿.全网销毁": "전체 네트워크 파괴",
	"销毁挖矿.我的销毁": "나의 파괴",
	"销毁挖矿.占比": "점유율",
	"销毁挖矿.分享收益": "수익 공유",
	"销毁挖矿.提现": "출금",
	"销毁挖矿.明细": "상세 내역",
	"销毁挖矿.已销毁": "파괴됨",
	"销毁挖矿.锁仓中": "잠금 중",
	"销毁挖矿.今日可领": "오늘 수령 가능",
	"销毁挖矿.开始销毁": "파괴 시작",
	"销毁挖矿.销毁记录": "파괴 기록",
	"销毁挖矿.选择销毁档位": "파괴 단계 선택",
	"销毁挖矿.个档位可选": "개 단계 선택 가능",
	"销毁挖矿.天": "일",
	"销毁挖矿.确认销毁": "파괴 확인",
	"销毁挖矿.销毁挖矿": "파괴 마이닝",
	"销毁挖矿.团队": "팀",
	"销毁挖矿.释放进度": "해제 진행률",
	"销毁挖矿.总收益": "총 수익",
	"销毁挖矿.每日释放": "일일 해제",
	"销毁挖矿.已到账": "입금됨",
	"销毁挖矿.待释放": "해제 대기",
	"销毁挖矿.自动释放中": "자동 해제 중",
	
	"销毁我的团队.我的团队": "나의 팀",
	"销毁我的团队.邀请好友": "친구 초대",
	"销毁我的团队.团队列表": "팀 목록",
	"销毁我的团队.直推人数": "직추 인원",
	"销毁我的团队.直推收益": "직추 수익",
	"销毁我的团队.我的邀请码": "나의 초대 코드",
	"销毁我的团队.复制": "복사",
	"销毁我的团队.我的邀请码": "나의 초대 코드",
	"销毁我的团队.复制链接": "링크 복사",
	"销毁我的团队.分享链接": "링크 공유",
	"销毁我的团队.邀请规则": "초대 규칙",
	"销毁我的团队.直推好友销毁可获得5%奖励": "직추 친구 파괴 시 5% 보상 획득 가능",
	"销毁我的团队.团队等级越高，极差收益越多": "팀 등급이 높을수록 차등 수익이 많아짐",
	"销毁我的团队.NFT节点极差:1%-5%": "NFT 노드 차등:1%-5%",
	"销毁我的团队.矿机领航者极差:1%-5%": "마이닝 머신 리더 차등:1%-5%",
	"销毁我的团队.流动性挖矿极差:R1-R10(1%-10%)": "유동성 마이닝 차등:R1-R10(1%-10%)",
	"销毁我的团队.质押NFT解锁团队奖励": "NFT 스테이킹으로 팀 보상 잠금 해제",
	"销毁我的团队.质押NFT后可获得团队极差奖励(1%-5%)，享受更多收益": "NFT 스테이킹 후 팀 차등 보상(1%-5%) 획득 가능, 더 많은 수익 즐기기",
	"销毁我的团队.立即质押NFT": "지금 NFT 스테이킹",
	"销毁我的团队.我的等级": "나의 등급",
	"销毁我的团队.极差": "차등",
	"销毁我的团队.领航者": "리더",
	"销毁我的团队.直推收益": "직추 수익",
	"销毁我的团队.团队收益": "팀 수익",
	"销毁我的团队.直推人数": "직추 인원",
	"销毁我的团队.团队总人数": "팀 총 인원",
	"销毁我的团队.团队销毁量": "팀 파괴량",
	"销毁我的团队.直推成员": "직추 멤버",
	"销毁我的团队.共": "총",
	"销毁我的团队.人": "명",
	"销毁我的团队.销毁量": "파괴량",
	"销毁我的团队.等级说明": "등급 설명",
	"销毁我的团队.R1-R10:流动性挖矿等级，极差1%-10%": "R1-R10:유동성 마이닝 등급, 차등1%-10%",
	"销毁我的团队.NFT节点:质押NFT获得，极差1%-5%": "NFT 노드:NFT 스테이킹 획득, 차등1%-5%",
	"销毁我的团队.矿机领航者:团队销毁达标，极差1%-5%": "마이닝 머신 리더:팀 파괴 달성, 차등1%-5%",
	"销毁我的团队.等级越高，团队收益越多": "등급이 높을수록 팀 수익이 많아짐",
	"销毁我的团队.质押NFT": "NFT 스테이킹",
	"销毁我的团队.质押NFT后将解锁团队极差奖励功能，享受1%-5%的团队收益分成": "NFT 스테이킹 후 팀 차등 보상 기능 잠금 해제, 1%-5% 팀 수익 분배 즐기기",
	"销毁我的团队.NFT数量": "NFT 수량",
	"销毁我的团队.个": "개",
	"销毁我的团队.质押周期": "스테이킹 주기",
	"销毁我的团队.永久": "영구",
	"销毁我的团队.团队极差": "팀 차등",
	"销毁我的团队.确认质押": "스테이킹 확인",
	
	
	"NUT.菜单.首页": "홈",
	"NUT.菜单.奖励": "보상",
	"NUT.菜单.介绍": "소개",
	"NUT.菜单.奖励池": "보상 풀",
	
	"NUT.首页.活跃": "활성",
	"NUT.首页.下一代DeFi生态代币": "차세대 DeFi 생태 토큰",
	"NUT.首页.燃烧池": "연소 풀",
	"NUT.首页.稳定池": "안정 풀",
	"NUT.首页.托底池": "바닥 풀",
	"NUT.首页.LP奖励": "LP 보상",
	"NUT.首页.参与质押": "스테이킹 참여",
	"NUT.首页.参与激励": "참여 인센티브",
	"NUT.首页.我的参与统计": "나의 참여 통계",
	"NUT.首页.总参与": "총 참여",
	"NUT.首页.份数": "인원수",
	"NUT.首页.预计收益": "예상 수익",
	"NUT.首页.参与数量": "참여 인원",
	"NUT.首页.余额": "잔액",
	"NUT.首页.最大": "최대",
	"NUT.首页.份": "인원",
	"NUT.首页.参与规则说明": "참여 규칙 설명",
	"NUT.首页.1,000 ROON =1份，可多次参与": "1,000 ROON =1인원, 여러 번 참여 가능",
	"NUT.首页.35%全网分红ROON": "35% 전체 네트워크 ROON 배당",
	"NUT.首页.65%自动组LP锁定999年": "65% 자동 LP 조합 999년 잠금",
	"NUT.首页.全链上执行，透明可查": "전체 체인 실행, 투명하게 확인 가능",
	"NUT.首页.收益分配": "수익 분배",
	"NUT.首页.全网分红": "전체 네트워크 배당",
	"NUT.首页.组LP锁定": "LP 조합 잠금",
	"NUT.首页.65 ROON中:32.5买入NUT + 32.5 ROON组LP": "65 ROON 중:32.5로 NUT 구매 + 32.5 ROON으로 LP 조합",
	"NUT.首页.最少": "최소",
	
	"NUT.奖励.我的奖励总览": "나의 보상 총괄",
	"NUT.奖励.可领取奖励": "수령 가능 보상",
	"NUT.奖励.已领取总额": "총 수령 완료",
	"NUT.奖励.税收分红": "세금 배당",
	"NUT.奖励.持币分红": "보유코인 배당",
	"NUT.奖励.LP奖励": "LP 보상",
	"NUT.奖励.NFT分红": "NFT 배당",
	"NUT.奖励.税收分红领取": "세금 배당 수령",
	"NUT.奖励.盈利税+砸盘税": "이익세+덤핑세",
	"NUT.奖励.盈利税分红": "이익세 배당",
	"NUT.奖励.回购": "매수",
	"NUT.奖励.砸盘税分红": "덤핑세 배당",
	"NUT.奖励.总可领取": "총 수령 가능",
	"NUT.奖励.领取时50%销毁，50%到账": "수령 시 50% 파괴, 50% 입금",
	"NUT.奖励.税收机制说明": "세금 메커니즘 설명",
	"NUT.奖励.盈利税20%:回购ROON分红给参与者": "이익세 20%: ROON 매수 후 참여자에게 배당",
	"NUT.奖励.盘税25%:每日8点AVE价格为准，跌1%扣2%": "시세세 25%: 매일 8시 AVE 가격 기준, 1% 하락 시 2% 차감",
	"NUT.奖励.最高下跌12.5%时税率达25%": "최대 12.5% 하락 시 세율 25%",
	"NUT.奖励.领取税收分红": "세금 배당 수령",
	
	"NUT.奖励.持币分红": "보유코인 배당",
	"NUT.奖励.手续费": "수수료",
	"NUT.奖励.可领取": "수령 가능",
	"NUT.奖励.下次分红": "다음 배당",
	"NUT.奖励.已领取": "수령 완료",
	"NUT.奖励.参与条件": "참여 조건",
	"NUT.奖励.持有": "보유",
	"NUT.奖励.领取费用": "수령 비용",
	"NUT.奖励.价值": "가치",
	"NUT.奖励.领取时50%销毁，50%到账": "수령 시 50% 파괴, 50% 입금",
	"NUT.奖励.领取奖励": "보상 수령",
	
	"NUT.奖励.LP贡献奖励": "LP 기여 보상",
	"NUT.奖励.我的流动性": "나의 유동성",
	"NUT.奖励.池份额": "풀 지분",
	"NUT.奖励.LP每小时自动撤出0.25%，0.125%燃烧，0.125%分红": "LP 매시간 자동 철회 0.25%, 0.125% 연소, 0.125% 배당",
	"NUT.奖励.添加流动性": "유동성 추가",
	"NUT.奖励.流动性池": "유동성 풀",
	"NUT.奖励.当前池子比例": "현재 풀 비율",
	"NUT.奖励.数量": "수량",
	"NUT.奖励.余额": "잔액",
	"NUT.奖励.请输入NUT数量": "NUT 수량을 입력하세요",
	"NUT.奖励.请输入ROON数量": "ROON 수량을 입력하세요",
	"NUT.奖励.最大": "최대",
	"NUT.奖励.花店容差": "슬리피지",
	"NUT.奖励.自定义": "사용자 지정",
	"NUT.奖励.取消": "취소",
	"NUT.奖励.确认添加": "추가 확인",
	
	"NUT.奖励.NFT资产分红": "NFT 자산 배당",
	"NUT.奖励.盈利税": "이익세",
	"NUT.奖励.节点NFT": "노드 NFT",
	"NUT.奖励.白名单NFT": "화이트리스트 NFT",
	"NUT.奖励.持有": "보유",
	"NUT.奖励.个": "개",
	"NUT.奖励.NFT分红规则": "NFT 배당 규칙",
	"NUT.奖励.节点NFT:50%分红(权重值分配)": "노드 NFT:50% 배당(가중치 분배)",
	"NUT.奖励.白名单NFT:50%分红(加权平均)": "화이트리스트 NFT:50% 배당(가중치 평균)",
	"NUT.奖励.激活条件: 持币≥100.000 NUT": "활성 조건: 보유코인≥100.000 NUT",
	"NUT.奖励.领取时50%销毁，50%到账": "수령 시 50% 파괴, 50% 입금",
	"NUT.奖励.领取全部NFT奖励": "전체 NFT 보상 수령",
	
	"NUT.介绍.NUT 代币": "NUT 토큰",
	"NUT.介绍.创新的Defi生态系统，多重分红机制": "혁신적인 Defi 생태계, 다중 배당 메커니즘",
	"NUT.介绍.代币信息": "토큰 정보",
	"NUT.介绍.代币名称": "토큰 이름",
	"NUT.介绍.代币符号": "토큰 심볼",
	"NUT.介绍.总供应量": "총 공급량",
	"NUT.介绍.一千万亿": "일천만억",
	"NUT.介绍.稳定比": "안정 비율",
	"NUT.介绍.美元兑日元": "달러당 엔화",
	"NUT.介绍.奖励代币": "보상 토큰",
	"NUT.介绍.三大资金池": "3대 자금풀",
	"NUT.介绍.燃烧池": "소각 풀",
	"NUT.介绍.NUT/ROON 交易对，持续燃烧通缩": "NUT/ROON 트레이딩 페어, 지속적 소각 디플레이션",
	"NUT.介绍.稳定池": "안정 풀",
	"NUT.介绍.NUT/USDR 交易对，价格稳定支": "NUT/USDR 트레이딩 페어, 가격 안정 지원",
	"NUT.介绍.拖底池": "바닥 지원 풀",
	"NUT.介绍.ROON 转账即交易，X314协议，隐藏性拖底": "ROON 전송 즉시 거래, X314 프로토콜, 숨겨진 바닥 지원",
	"NUT.介绍.交易手续费分配": "거래 수수료 분배",
	"NUT.介绍.回流底池燃烧": "재유입 바닥 풀 소각",
	"NUT.介绍.回流ROON LP池": "재유입 ROON LP 풀",
	"NUT.介绍.价格拖底": "가격 바닥 지원",
	"NUT.介绍.生态建设": "생태계 구축",
	"NUT.介绍.持币分红": "보유 배당",
	"NUT.介绍.回购销毁": "매입 소각",
	"NUT.介绍.LP池机制": "LP 풀 메커니즘",
	"NUT.介绍.LP每小时自动撤出0.25%": "LP 매시간 자동 철수 0.25%",
	"NUT.介绍.其中0.125%自动燃烧销毁": "그 중 0.125% 자동 소각 파괴",
	"NUT.介绍.另外0.125%分红给LP提供者": "나머지 0.125% LP 제공자에게 배당",
	"NUT.介绍.1%手续费实时分红给LP用户": "1% 수수료 실시간 LP 사용자에게 배당",
	"NUT.介绍.参与质押机制": "스테이킹 메커니즘 참여",
	"NUT.介绍.向合约地址打入ROON代币100": "컨트랙트 주소에 ROON 토큰 100 송금",
	"NUT.介绍.ROON=1份，可多次参与": "ROON=1份, 여러 번 참여 가능",
	"NUT.介绍.全链上执行，透明可查": "전체 체인 실행, 투명하게 확인 가능",
	"NUT.介绍.收益分配": "수익 분배",
	"NUT.介绍.35%全网分红ROON": "35% 전체 네트워크 ROON 배당",
	"NUT.介绍.65%自动组LP锁定999年": "65% 자동 LP 생성하여 999년 잠금",
	"NUT.介绍.65 ROON中:32.5买入NUT + 32.5 ROON组LP": "65 ROON 중:32.5 NUT 매수 + 32.5 ROON LP 생성",
	"NUT.介绍.税收机制": "세금 메커니즘",
	"NUT.介绍.盈利税（20%）": "이익세(20%)",
	"NUT.介绍.20%回购ROON分给参与者": "20% 매입 ROON 참여자에게 분배",
	"NUT.介绍.其中10%分红给LP用户": "그 중 10% LP 사용자에게 배당",
	"NUT.介绍.5%的利润将分给NFT资产持有者": "5%의 이익이 NFT 자산 보유자에게 분배",
	"NUT.介绍.5%用于市值管理": "5% 시가총액 관리에 사용",
	"NUT.介绍.砸盘税 (最高25%)": "덤핑세 (최대 25%)",
	"NUT.介绍.每天早上8点AVE价格为准": "매일 오전 8시 AVE 가격 기준",
	"NUT.介绍.跌1%扣2%手续费": "1% 하락 시 2% 수수료 차감",
	"NUT.介绍.最高下跌12.5%时税率达25%": "최대 하락 12.5% 시 세율 25% 도달",
	"NUT.介绍.25% 回购ROON分给参与者": "25% 매입 ROON 참여자에게 분배",
	"NUT.介绍.持币分红": "보유 배당",
	"NUT.介绍.0.5%手续费用于持币分红ROON": "0.5% 수수료 ROON 보유 배당에 사용",
	"NUT.介绍.单地址持币>100,000 NUT可参与": "단일 주소 보유 >100,000 NUT 참여 가능",
	"NUT.介绍.前台手动领取，支付50% NUT价值": "프론트엔드 수동 수령, 50% NUT 가치 지불",
	"NUT.介绍.领取时50%销毁，50%到账": "수령 시 50% 소각, 50% 입금",
	"NUT.介绍.NFT分红机制": "NFT 배당 메커니즘",
	"NUT.介绍.节点NFT(50%)": "노드 NFT(50%)",
	"NUT.介绍.权重值分配分红": "가중치 값 분배 배당",
	"NUT.介绍.持币≥100.000 NUT激活": "보유 ≥100.000 NUT 활성화",
	"NUT.介绍.白名单NFT(50%)": "화이트리스트 NFT(50%)",
	"NUT.介绍.加权平均分配分红": "가중 평균 분배 배당",
	"NUT.介绍.重要提示": "중요 안내",
	"NUT.介绍.所有盈利税和砸盘税分红ROON": "모든 이익세와 덤핑세는 ROON으로 배당",
	"NUT.介绍.领取时50%打入黑洞销毁，50%到用户钱包": "수령 시 50% 블랙홀로 파괴, 50% 사용자 지갑으로",
	"NUT.介绍.全链上执行，透明可查": "전체 체인 실행, 투명하게 확인 가능",
	"NUT.介绍.智能合约自动执行，无需人工干预": "스마트 컨트랙트 자동 실행, 인공 개입 불필요",
	
	"NUT.奖励池.资金池总览": "자금풀 개요",
	"NUT.奖励池.实时监控三大资金池运作状态": "3대 자금풀 운영 상태 실시간 모니터링",
	"NUT.奖励池.资金池总价值": "자금풀 총 가치",
	"NUT.奖励池.24小时注入": "24시간 주입",
	"NUT.奖励池.24小时分配": "24시간 분배",
	"NUT.奖励池.24小时销毁": "24시간 소각",
	"NUT.奖励池.LP池": "LP 풀",
	"NUT.奖励池.质押池": "스테이킹 풀",
	"NUT.奖励池.税收池": "세금 풀",
	"NUT.奖励池.LP池流动性池": "LP 풀 유동성 풀",
	"NUT.奖励池.运行中": "운영 중",
	"NUT.奖励池.交易手续费的35%注入LP池，增强流动性": "거래 수수료의 35% LP 풀에 주입하여 유동성 강화",
	"NUT.奖励池.池子总价值": "풀 총 가치",
	"NUT.奖励池.今日注入": "오늘 주입",
	"NUT.奖励池.累计分配": "누적 분배",
	"NUT.奖励池.累计注入": "누적 주입",
	"NUT.奖励池.查看详细数据": "상세 데이터 보기",
	"NUT.奖励池.操作记录": "운영 기록",
	"NUT.奖励池.查看全部": "전체 보기",
	"NUT.奖励池.注入": "주입",
	"NUT.奖励池.加载更多": "더 보기",
	
	"NUT.奖励池.LP流动性池": "LP 유동성 풀",
	"NUT.奖励池.详细数据分析": "상세 데이터 분석",
	"NUT.奖励池.概览": "개요",
	"NUT.奖励池.图表": "차트",
	"NUT.奖励池.记录": "기록",
	"NUT.奖励池.占比": "비중",
	"NUT.奖励池.数量": "수량",
	"NUT.奖励池.LP代币": "LP 토큰",
	"NUT.奖励池.持有人数": "보유자 수",
	"NUT.奖励池.年华收益": "연수익률",
	"NUT.奖励池.日奖励": "일일 보상",
	"NUT.奖励池.7日资金流动趋势": "7일 자금 흐름 트렌드",
	"NUT.奖励池.资金分配占比": "자금 분배 비중",
	"NUT.奖励池.回购": "매입",
	"NUT.奖励池.销毁": "소각",
	"NUT.奖励池.分配": "분배",
	
	"NUT.奖励池.质押奖励池": "스테이킹 보상 풀",
	"NUT.奖励池.交易手续费的25%用于质押奖励分配": "거래 수수료의 25% 스테이킹 보상 분배에 사용",
	"NUT.奖励池.总质押量": "총 스테이킹량",
	"NUT.奖励池.质押人数": "스테이킹 참여자 수",
	"NUT.奖励池.平均质押": "평균 스테이킹",
	"NUT.奖励池.待领奖励": "미수령 보상",
	
	"NUT.奖励池.税收回购池": "세금 매입 풀",
	"NUT.奖励池.交易手续费的40%用于税收回购和销毁": "거래 수수료의 40% 세금 매입과 소각에 사용",
	"NUT.奖励池.今日回购": "오늘 매입",
	"NUT.奖励池.累计销毁": "누적 소각",
	"NUT.奖励池.盈利税": "이익세",
	"NUT.奖励池.砸盘税": "덤핑세",
	"NUT.奖励池.回购总额": "매입 총액",
	"NUT.奖励池.销毁总额": "소각 총액",
	"NUT.奖励池.分配总额": "분배 총액",
	"NUT.奖励池.日回购": "일일 매입",

	"弹窗.复制成功": "복사되었습니다",
	"弹窗.复制失败": "복사 실패",
	"弹窗.连接钱包": "지갑 연결",
	"弹窗.取消": "취소",
	"弹窗.确认": "확인",
	"弹窗.提示": "알림",
	"弹窗.错误": "오류",
	"弹窗.成功": "성공",
	"弹窗.警告": "경고",
	"弹窗.信息": "정보",
	"弹窗.加载中": "로딩 중",
	"弹窗.请稍候": "잠시만 기다려주세요",
	"弹窗.操作成功": "작업 성공",
	"弹窗.操作失败": "작업 실패",
	"弹窗.网络错误": "네트워크 오류",
	"弹窗.确认删除": "삭제 확인",
	"弹窗.删除": "삭제",
	"弹窗.编辑": "편집",
	"弹窗.保存": "저장",
	"弹窗.关闭": "닫기",
	"弹窗.是": "예",
	"弹窗.否": "아니오",
	"弹窗.确定": "확인",
	"弹窗.上级邀请码": "상위 초대 코드",
	"弹窗.知道了": "알겠습니다",
	"弹窗.请输入邀请码": "초대 코드를 입력하세요",

	"吐司.敬请期待": "기대해 주세요",
	"吐司.操作成功": "작업 성공",
	"吐司.操作失败": "작업 실패",
	"吐司.请在钱包中打包": "지갑에서 확인하세요",
	"吐司.暂未开放": "아직 오픈되지 않았습니다",
	"吐司.用户拒绝提供程序访问": "사용자가 애플리케이션 접근을 거부했습니다",
	"吐司.请刷新重试": "새로고침 후 다시 시도하세요",
	"吐司.请输入邀请码": "초대 코드를 입력하세요",
	"吐司.操作成功请稍后刷新查看": "작업 성공, 잠시 후 새로고침하여 확인하세요",
	"吐司.添加流动性成功": "유동성 추가 성공",
	"吐司.余额不足": "잔액이 부족합니다",
	"吐司.收款地址无效": "수신 주소가 유효하지 않습니다",

	"解押NFT": "NFT 언스테이크",
	"质押NFT": "NFT 스테이크",
	"选择NFT解押": "언스테이크할 NFT 선택",
	"选择NFT质押": "스테이크할 NFT 선택",
	"当前节点等级:黄金": "현재 노드 레벨: 골드",
	"jiemiao": "Level3 NFT만 언스테이크 가능",
	"zhimiao": "Level3 NFT만 스테이크 가능",
	"已选择": "선택 완료",
	"黄金": "골드",
	"解押": "언스테이크",
	"质押": "스테이크",
	"个": "개",

	"添加流动性": "유동성 추가",
	"交换代币": "토큰 교환",
	"从": "부터",
	"余额": "잔액",
	"请输入": "입력해주세요",
	"至": "까지",
	"池股份": "풀 주식",
	"当前年利率": "현재 연이자율",
	"代币": "토큰",
	"美元稳定币": "이더리움-USD 스테이블코인",
	"热门池": "인기 풀",
	"兑换美元稳定币兑换": "USD 스테이블코인 교환",
	"以太坊": "이더리움 (ETH)",
	"亿美元": "억 달러",
	"四月": "4월",
	"我的流动池": "내 유동성 풀",
	"总计": "총계",
	"我的稳定币": "내 스테이블코인",
	"小时交易量": "시간당 거래량",
	"百万": "백만",
	"移除": "제거",
	"添加更多": "더 추가",
	"总薪酬": "총 보상",
	"池": "풀",
	"交易池": "거래 풀",
	"领取所有奖励": "모든 보상 수령",
	"移除流动性": "유동성 제거",
	"确定要移除": "풀의 유동성을",
	"我的流动性": "내 유동성",
	"预计收益": "예상 수익",
	"取消": "취소",
	"确认移除": "제거 확인",
	"跨链桥": "크로스체인 브릿지",
	"预计到账时间": "예상 입금 시간",
	"分钟到账": "분 내에 입금",
	"安全级别": "보안 레벨",
	"高": "높음",
	"手续费": "수수료",
	"美元": "달러 (USD)",
	"多边形": "폴리곤 (MATIC)",
	"代币数量": "토큰 수량",
	"": "USD 스테이블코인",
	"接收地址": "수신 주소",
	"分钟": "분",
	"桥接手续费": "브릿지 수수료",
	"目标链手续费": "목표 체인 수수료",
	"总手续费": "총 수수료",
	"开始跨链": "크로스체인 시작",
	"最近跨链记录": "최근 크로스체인 기록",
	"分钟前": "분 전",
	"待处理": "대기 중",
	"完成": "완료",
	"支持的网络": "지원되는 네트워크",
	"企业绩效管理": "기업 성과 관리 (EPM)",
	"选择币种": "화폐 선택",
	"滑点容差": "슬리피지 허용치",
	"费率": "수수료율",
	"滑动": "슬라이드",
	"百分比": "퍼센티지",
	"网络费用": "네트워크 수수료",
	"最近的交换": "최근 교환 내역",

	"我的池": "내 유동성 풀",
	'使用我的地址':'내 주소 사용',
	    "我的LP.暂无数据": "데이터 없음",
	    "我的LP.复投": "재투자",
	}
